import React from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';

const ShareIcon = ({ shared, shareUrl }) => {
  if (shared) {
    if (!isEmpty(shareUrl)) {
      return (
        <a href={Meteor.absoluteUrl(`${shareUrl}`)} target="_blank" rel="noreferrer noopener">
          <FontAwesomeIcon icon="link" size="lg" className="text-primary pr-1 align-center" />
        </a>
      );
    }
    return (
      <FontAwesomeIcon
        icon={['far', 'check-circle']}
        size="lg"
        className="text-success pr-1 align-self-center"
      />
    );
  }
  return <FontAwesomeIcon icon="ban" size="lg" className="text-danger pr-1 align-self-center" />;
};

ShareIcon.defaultProps = {
  shareUrl: ''
};

ShareIcon.propTypes = {
  shared: PropTypes.bool.isRequired,
  shareUrl: PropTypes.string
};

export default ShareIcon;
